/* file description */

import React, { FC, useState } from 'react';
import { Modal } from 'antd';
import { downloadExl } from '../TableImport/effect/util';
import { ExportProps } from './type';

export const Export: FC<ExportProps> = ({
  exportVisible,
  setExportVisible,
  moduleInfo,
  mergeColumns,
  selectedRows,
  rowSelection,
  request,
  namespaceID,
  moduleID,
  filter,
  requestParams,
  searchParams,
  sorter,
}) => {
  const closeModal = () => {
    setExportVisible(false);
  };

  const exportExcel = async () => {
    const codeObject: any = {};
    const fieldNames: any = {};
    mergeColumns.forEach((item: any) => {
      codeObject[item.dataIndex] = item.dataIndex;
      fieldNames[item.dataIndex] = item.title;
    });
    let exportData = [];
    if (rowSelection && selectedRows?.length > 0) {
      exportData = selectedRows;
    } else {
      const res = await request({
        namespaceID,
        moduleID,
        filter,
        moduleInfo,
        requestParams,
        current: 1,
        pageSize: 1000,
        ...(searchParams || {}),
      }, sorter || {});
      exportData = res?.data || [];
    }
    const data = [codeObject, ...(exportData || [])];
    downloadExl(data, `${moduleInfo.name}数据列表`, '', fieldNames);
    setExportVisible(false);
  };

  if (!exportVisible) { return <></>; }
  return (
    <Modal
      title="导出"
      width="600px"
      visible
      okText="确认导出"
      cancelText="取消"
      onCancel={closeModal}
      onOk={() => exportExcel()}
      maskClosable={false}
    >
      <div style={{ textAlign: 'center' }}>
        目前支持最多导出1000条数据
      </div>
    </Modal>
  );
};
